import { render, staticRenderFns } from "./Sakq.vue?vue&type=template&id=265180fe&scoped=true"
import script from "./Sakq.vue?vue&type=script&lang=js"
export * from "./Sakq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265180fe",
  null
  
)

export default component.exports